import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContactCard from "../../component/ContactCard";
import { Timeline, TimelineBlock } from "../../component/Timeline";
import Image from "../../component/Image";
import Rules from "../../component/Rules";
import Pricing from "../../component/Pricing";
import Countdown from "../../component/Countdown";

const rules = [
  "Peserta merupakan siswa/i SMA/SMK/MA/sederajat di seluruh Indonesia yang dibuktikan dengan Kartu Pelajar.",
  "Peserta merupakan tim yang terdiri dari 2 orang dan berasal dari SMA yang sama.",
  "Peserta 1 sebagai Ketua Tim WAJIB mengikuti prosedur pendaftaran hingga selesai.",
  "Peserta yang dianggap sah adalah peserta yang telah mendaftar dan mengikuti prosedur pendaftaran hingga selesai.",
  "Peserta WAJIB mengunggah twibbon ARSEN 2026 di Instagram pribadi dan tag ke Instagram @himasta_unair, @arsenunair, serta tag 3 akun teman lainnya menggunakan caption yang telah disediakan. Twibbon dan caption dapat diunduh pada https://bit.ly/TwibbonASO2026.",
  "Peserta yang telah mendaftarkan diri tidak dapat digantikan oleh orang lain.",
  "Peserta yang mengundurkan diri setelah mendaftar tidak dapat meminta pengembalian biaya pendaftaran dan dianggap gugur.",
  "Peserta WAJIB menjaga etika dan sopan santun dalam seluruh rangkaian kegiatan lomba, baik dalam komunikasi dengan panitia maupun dalam unggahan media sosial.",
  "Peserta WAJIB mematuhi segala peraturan yang telah ditetapkan oleh panitia dan jika peserta melanggar peraturan ASO 2026, maka akan diberikan sanksi sesuai peraturan yang berlaku.",
];

function Aso() {
  const [isCountdownEnded, setIsCountdownEnded] = useState(false);

  useEffect(() => {


    const targetDate = new Date("2026-08-15T09:00:00+07:00");
    const now = new Date();
    setIsCountdownEnded(now >= targetDate);

    const interval = setInterval(() => {
      const currentTime = new Date();
      setIsCountdownEnded(currentTime >= targetDate);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-3 text-center md:text-left max-w-6xl mx-auto w-full px-5 sm:px-8 my-16">
      <div className="flex items-center flex-col md:flex-row gap-3 py-8">
        <div className="flex flex-col gap-3">
          <div data-aos="fade-up">
            <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
              CABANG KEGIATAN
            </div>
            <div className="text-5xl md:text-6xl font-bold">
              <span className="text-arsen-tertiary">A</span>irlangga{" "}
              <span className="text-arsen-tertiary">S</span>tatistics{" "}
              <span className="text-arsen-tertiary">O</span>lympiad{" "}
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="bg-arsen-tertiary-100 text-arsen-tertiary rounded-full md:w-fit px-4 py-1 font-medium text-sm"
          >
            Tingkat Siswa se-Indonesia
          </div>
          <div data-aos="fade-up" data-aos-delay="150">
            <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
              TEMA KOMPETISI
            </div>
            <div className="text-sm md:text-lg leading-6 text-gray-700">
              Transforming Raw Information into Strategic Insights through Statistical Exploration Amidst Global Volatility
            </div>
          </div>
          {isCountdownEnded && (
            <div
              data-aos="fade-up"
              data-aos-delay="200"
              className="flex flex-col md:flex-row gap-2.5 text-md md:text-lg text-center md:text-left text-white mb-8"
            >
              <Link
                to="https://bit.ly/PendaftaranASO2026"
                target="_blank"
                className="bg-arsen-tertiary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Daftar Sekarang
              </Link>
              <Link
                to="https://bit.ly/GuidebookASO2026"
                target="_blank"
                className="text-center text-arsen-tertiary border border-arsen-tertiary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan Kegiatan
              </Link>
              <a
                href="#timeline"
                className="text-center text-arsen-tertiary border border-arsen-tertiary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Timeline Kompetisi
              </a>
            </div>
          )}
          <div data-aos="fade-up" data-aos-delay="250" className="mt-4">
            <Countdown
              targetDate="2026-08-15T09:00:00+07:00"
              title="Countdown Pembukaan Lomba (15 Agustus 2026 09.00)"
            />
          </div>
        </div>
        <div
          data-aos="fade-up"
          className="relative md:ml-4 text-white text-center justify-center"
        >
          <img
            src="/assets/img/logo/aso2026.svg"
            alt="ASO 2026 Logo"
            width="400"
            className="w-full max-w-[400px] h-auto"
          />
          <img
            src="/assets/img/mascot/mascot3.svg"
            alt=""
            className="absolute bottom-0 -right-2 sm:right-2 w-20 sm:w-24 h-auto"
          />
        </div>
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-12 md:items-start">
        <div data-aos="zoom-in" className="flex flex-col gap-3 md:flex-1">
          <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
            TENTANG KOMPETISI
          </div>
          <p className="text-justify text-gray-700 text-md">
            <span className="font-bold">Airlangga Statistics Olympiad</span>
            <span className="font-normal">
              {" "}
              (ASO) merupakan ajang bergengsi yang ditujukan bagi siswa/siswi SMA/sederajat yang memiliki minat dan potensi dalam bidang statistika. Dengan mengangkat tema{" "}
              <b>
                Transforming Raw Information into Strategic Insights through Statistical Exploration Amidst Global Volatility,
              </b>
              {" "}kompetisi ini bertujuan untuk mengembangkan kemampuan peserta dalam mengeksplorasi, menganalisis, dan menginterpretasikan data menjadi insight yang bernilai. Melalui berbagai tantangan yang menguji pemahaman konsep statistika dan penalaran analitis, peserta diharapkan mampu mengasah kemampuan berpikir logis, menyelesaikan permasalahan berbasis data, serta mengambil keputusan yang tepat di tengah dinamika dan ketidakpastian global.
            </span>
          </p>
          <div className="mt-3">
            <Pricing
              color="tertiary"
              batches={[
                {
                  name: "Batch 1",
                  price: 50000,
                  period: "15 Agustus – 5 September 2026",
                },
                {
                  name: "Batch 2",
                  price: 70000,
                  period: "7 September – 14 September 2026",
                },
              ]}
              note="Diikuti oleh tim yang terdiri dari 2 orang dari sekolah yang sama."
            />
          </div>
        </div>
        <div
          data-aos="zoom-in"
          className="flex w-full flex-col items-center gap-2 md:w-1/3 md:flex-none"
        >
          <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
            POSTER KEGIATAN
          </div>
          <div className="w-2/3 sm:w-1/2 md:w-full">
            <Image
              src="/assets/img/poster/Poster ASO 2026.jpg"
              alt="ASO Poster"
            />
          </div>
        </div>
      </div>
      <div data-aos="zoom-in" className="flex flex-col gap-3 mb-4">
        <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
          Syarat dan Ketentuan
        </div>
        <Rules rules={rules} />
      </div>
      <div data-aos="zoom-in" className="flex flex-col gap-3" id="timeline">
        <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
          TIMELINE KOMPETISI ASO
        </div>
        <div className="grid grid-cols-1 gap-x-8 gap-y-2 md:grid-cols-2 md:items-start">
          <Timeline month="Agustus - September">
          <TimelineBlock date="15 Agustus – 5 September 2026">
            Pendaftaran Batch 1
          </TimelineBlock>
          <TimelineBlock date="7 September – 14 September 2026">
            Pendaftaran Batch 2
          </TimelineBlock>
          <TimelineBlock date="15 September 2026">
            Technical Meeting 1
          </TimelineBlock>
          <TimelineBlock date="20 September 2026">
            Babak Penyisihan (CBT)
          </TimelineBlock>
          <TimelineBlock date="22 September 2026">
            Pengumuman Semifinalis
          </TimelineBlock>
          <TimelineBlock date="22 – 23 September 2026">
            Registrasi Ulang Semifinalis
          </TimelineBlock>
          <TimelineBlock date="25 September 2026">
            Technical Meeting 2
          </TimelineBlock>
        </Timeline>

        <Timeline month="Oktober">
          <TimelineBlock date="4 Oktober 2026">
            Babak Semifinal
          </TimelineBlock>
          <TimelineBlock date="18 Oktober 2026">
            Pengumuman Finalis
          </TimelineBlock>
          <TimelineBlock date="19 Oktober – 21 Oktober 2026">
            Registrasi Ulang Finalis
          </TimelineBlock>
          <TimelineBlock date="24 Oktober 2026">
            Technical Meeting 3
          </TimelineBlock>
          <TimelineBlock date="31 Oktober 2026">
            Babak Final dan Closing Ceremony
          </TimelineBlock>
        </Timeline>
        </div>
      </div>

      <div data-aos="fade-right" className="flex flex-col gap-4 mt-12 mb-6">
        <div className="font-bold text-sm tracking-widest text-arsen-tertiary-500 uppercase">
          Informasi Lainnya
        </div>
        {isCountdownEnded && (
          <>
            <div className="flex-col justify-start md:items-start flex">
              <div className="text-center md:text-left text-black text-[32px] font-bold">
                What Are You Waiting For?
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-2.5 text-sm text-center md:text-left text-white mb-8">
              <Link
                to="https://bit.ly/PendaftaranASO2026"
                target="_blank"
                className="bg-arsen-tertiary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Pendaftaran
              </Link>
              <Link
                to="https://bit.ly/GuidebookASO2026"
                target="_blank"
                className="text-center text-arsen-tertiary border border-arsen-tertiary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan
              </Link>
            </div>
          </>
        )}
      </div>
      <div data-aos="fade-right">
        <ContactCard event="ASO" />
      </div>
    </div>
  );
}

export default Aso;
